import React from "react";


interface Styles {
    rootStyle: React.CSSProperties
    formStyle: React.CSSProperties
    formButtonStyle: React.CSSProperties
    color: React.CSSProperties
    fontSize: React.CSSProperties
}

export interface WithStylesProps {
    styles: Styles
}

function WithStyles<T extends WithStylesProps>(WrappedComponent: React.ComponentType<T>) {
    return class extends React.Component<Omit<T, keyof WithStylesProps>> {
        render() {
            const styles: Styles = {
                rootStyle: {
                    width: "100%",
                    height: "100%",
                    margin: "20px",
                    textAlign: "center",
                },
                formStyle: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '20px',
                    width: '100%'
                },
                formButtonStyle: {
                    display: 'flex',
                    justifyContent: 'center',
                    color: 'white'
                },
                color: { color: "#474F5E" },
                fontSize: { fontSize: 22 }
            }

            return <WrappedComponent {...this.props as T} styles={styles} />
        }
    }
}

export default WithStyles